/**
 * @generated SignedSource<<eb75e79753b13152c73afa33111133ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CommentType = "REOPEN" | "RESOLVE" | "TEXT";
export type ResolvedModalQuery$variables = {
  id: string;
};
export type ResolvedModalQuery$data = {
  readonly node: {
    readonly rawDraftJson?: any;
    readonly resolvedComments?: ReadonlyArray<{
      readonly segment: any | null;
      readonly threadKey: string;
      readonly threads: ReadonlyArray<{
        readonly comments: ReadonlyArray<{
          readonly createdAt: string | null;
          readonly editedAt: string | null;
          readonly html: string;
          readonly id: string;
          readonly isDeleted: boolean;
          readonly text: string;
          readonly type: CommentType;
          readonly user: {
            readonly fullName: string;
            readonly id: string;
            readonly image: string;
            readonly isExternal: boolean;
            readonly isGuest: boolean;
            readonly isTopUser: boolean;
          };
        }>;
        readonly id: string;
        readonly key: string;
        readonly resolvedAt: string | null;
        readonly resolvedBy: {
          readonly fullName: string;
          readonly id: string;
          readonly image: string;
          readonly isExternal: boolean;
          readonly isGuest: boolean;
          readonly isTopUser: boolean;
        } | null;
      }>;
    }> | null;
  } | null;
  readonly viewer: {
    readonly user: {
      readonly account: {
        readonly id: string;
      };
      readonly id: string;
      readonly isGuest: boolean;
    };
  };
};
export type ResolvedModalQuery = {
  response: ResolvedModalQuery$data;
  variables: ResolvedModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v4 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "image",
    "storageKey": null
  },
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isTopUser",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isExternal",
    "storageKey": null
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rawDraftJson",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteResolvedComments",
      "kind": "LinkedField",
      "name": "resolvedComments",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "threadKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "segment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CommentThread",
          "kind": "LinkedField",
          "name": "threads",
          "plural": true,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "resolvedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "resolvedBy",
              "plural": false,
              "selections": (v4/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Comment",
              "kind": "LinkedField",
              "name": "comments",
              "plural": true,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "editedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isDeleted",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "text",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "html",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResolvedModalQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResolvedModalQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v5/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e673e266c1f4e83494f5cd23255fd7b8",
    "id": null,
    "metadata": {},
    "name": "ResolvedModalQuery",
    "operationKind": "query",
    "text": "query ResolvedModalQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on Note {\n      rawDraftJson\n      resolvedComments {\n        threadKey\n        segment\n        threads {\n          id\n          key\n          resolvedAt\n          resolvedBy {\n            id\n            fullName\n            image\n            isGuest\n            isTopUser\n            isExternal\n          }\n          comments {\n            id\n            createdAt\n            editedAt\n            isDeleted\n            text\n            html\n            type\n            user {\n              id\n              fullName\n              image\n              isGuest\n              isTopUser\n              isExternal\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  viewer {\n    user {\n      id\n      isGuest\n      account {\n        __typename\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0704e3d366e53634697b9937eeef73cd";

export default node;
